import { Injectable } from '@angular/core';
import { APPCONFIG } from '../config';
import { Observable } from 'rxjs';
import { EasyMarineHttpClient } from '../_utils/easy-marine-http-client';
import { D4signAccountBalanceDTO } from '../_models/_dto/d4sign-account-balance.dto';
import { DocumentContract } from '../_models/document-contract';

@Injectable()
export class ContractDocumentService {

    constructor(
        private http: EasyMarineHttpClient
    ) { }

    getAllSafes(): Observable<any[]> {
        return this.http.get(`${APPCONFIG.apiHost}/secure/contract/safes-list`)
            .map((response: any) => response.data.safes);
    }

    getAccountBalance(): Observable<D4signAccountBalanceDTO> {
        return this.http.get(`${APPCONFIG.apiHost}/secure/contract/account-balance`)
            .map((response: any) => response.data.accountBalance);
    }

    getProcessingSignaturesDocuments(): Observable<DocumentContract[]> {
        return this.http.get(`${APPCONFIG.apiHost}/secure/contract/documents-processing-signatures`)
            .map((response: any) => response.data.documents as DocumentContract[]);
    }

    getProcessingFileDocuments(): Observable<DocumentContract[]> {
        return this.http.get(`${APPCONFIG.apiHost}/secure/contract/documents-processing-file`)
            .map((response: any) => response.data.documents as DocumentContract[]);
    }

    sendProcessingSignaturesDocuments(ids: number[]): Observable<void> {
        const stringIds = ids.toString();
        return this.http.put(`${APPCONFIG.apiHost}/secure/contract/send-documents-to-signature-adm/${stringIds}`, null)
            .map((response: any) => response as any);
    }

    sendProcessingFileDocuments(ids: number[]): Observable<void> {
        const stringIds = ids.toString();
        return this.http.put(`${APPCONFIG.apiHost}/secure/contract/send-documents-to-d4sign-adm/${stringIds}`, null)
            .map((response: any) => response as any);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_services/contract-document.service.ts